<template>
  <div class="actions is-centered">
    <div
      class="modal"
      :class="{ 'is-active': modal }"
    >
      <div class="modal-background" />
      <div class="modal-content is-flex is-centered">
        <div class="box is-centered confirmation">
          <div class="field">
            <div class="label">
              ¿Estas seguro de cancelar esta nómina?
            </div>
            <div class="control is-centered">
              <div class="field is-grouped">
                <p class="control">
                  <a
                    class="button is-success"
                    :class="{ 'is-loading': isLoading }"
                    :disabled="isLoading"
                    @click="cancelById"
                  >
                    <b-icon
                      size="is-small"
                      icon="check"
                    />
                    <span>
                      Sí
                    </span>
                  </a>
                </p>
                <p class="control">
                  <a
                    class="button is-danger"
                    :class="{ 'is-loading': isLoading }"
                    :disabled="isLoading"
                    @click="onCloseModal"
                  >
                    <b-icon
                      size="is-small"
                      icon="close"
                    />
                    <span>
                      No
                    </span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="onCloseModal"
      />
    </div>

    <AppRadialMenu
      :size="36"
      :item-size="48"
      :radius="95"
      :angle-restriction="180"
      :rotate="270"
    >
      <AppRadialMenuItem
        class="tooltip is-tooltip-primary has-background-primary has-text-white"
        data-tooltip="Detalle de nómina"
      >
        <RouterLink
          class="action-option"
          :to="{ name: 'PayrollDetail', params: { uuid: id } }"
        >
          <BIcon
            icon="eye"
            class="action-option-icon"
          />
        </RouterLink>
      </AppRadialMenuItem>

      <AppRadialMenuItem
        v-if="![201, 202].includes(invoice.operation.status)"
        class="tooltip is-tooltip-success has-background-success has-text-white"
        data-tooltip="Reenviar XML y PDF"
      >
        <a
          class="action-option"
          @click="sendEmail"
        >
          <BIcon
            icon="send"
            class="action-option-icon"
          />
        </a>
      </AppRadialMenuItem>

      <AppRadialMenuItem
        v-if="![201, 202].includes(invoice.operation.status) && !showUpdateCfdiStatus(invoice)"
        class="tooltip is-tooltip-danger has-background-danger has-text-white"
        data-tooltip="Cancelar nómina"
      >
        <a
          class="action-option"
          @click="cancelInvoice"
        >
          <BIcon
            icon="cancel"
            class="action-option-icon"
          />
        </a>
      </AppRadialMenuItem>

      <AppRadialMenuItem
        v-if="showUpdateCfdiStatus(invoice)"
        data-tooltip="Actualizar Estado CFDI"
        class="tooltip is-tooltip-danger has-background-danger has-text-white"
      >
        <UpdateCfdiStatus :invoice="invoice" />
      </AppRadialMenuItem>

      <AppRadialMenuItem
        class="tooltip is-tooltip-info has-background-info has-text-white"
        data-tooltip="Descargar XML"
      >
        <a
          class="action-option"
          @click="download('xml')"
        >
          <BIcon
            icon="cloud-download"
            class="action-option-icon"
          />
          <span class="close-label">
            xml
          </span>
        </a>
      </AppRadialMenuItem>

      <AppRadialMenuItem
        v-if="![201, 202].includes(invoice.operation.status)"
        class="tooltip is-tooltip-info has-background-info has-text-white"
        data-tooltip="Descargar PDF"
      >
        <a
          class="action-option"
          @click="download('pdf')"
        >
          <BIcon
            icon="cloud-download"
            class="action-option-icon"
          />
          <span class="close-label">
            pdf
          </span>
        </a>
      </AppRadialMenuItem>
      <AppRadialMenuItem
        v-if="![201, 202].includes(invoice.operation.status)"
        class="tooltip is-tooltip-success has-background-success has-text-white"
        data-tooltip="Regenerar PDF"
      >
        <a
          class="action-option"
          @click="regeneratePdf('pdf', invoice)"
        >
          <BIcon
            icon="autorenew"
            class="action-option-icon"
          />
          <span class="close-label">
            pdf
          </span>
        </a>
      </AppRadialMenuItem>
    </AppRadialMenu>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import cfdiStatuses from '../../../constants/CfdiStatus';

export default {
  name: 'HistoryStampedActions',
  components: {
    AppRadialMenu: () => import(/* webpackChunkName: "app-radial-menu" */ '../../AppRadialMenu.vue'),
    AppRadialMenuItem: () => import(/* webpackChunkName: "app-radial-menu-item" */ '../../AppRadialMenuItem.vue'),
    UpdateCfdiStatus: () => import(/* webpackChunkName: "update-cfdi-status" */ '../../../components/Invoices/History/UpdateCfdiStatus.vue'),
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    invoice: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      modal: false,
    };
  },
  computed: {
    ...mapState({
      company: state => state.company.id,
    }),
  },
  mounted() {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.modal) {
        this.modal = false;
      }
    }, false);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', () => {});
  },
  methods: {
    ...mapActions({
      cancelByUuid: 'invoice/cancelByUuid',
    }),
    showUpdateCfdiStatus(invoice) {
      return invoice.operation.cfdiStatus
        ? invoice.operation.cfdiStatus === cfdiStatuses.InProgress
        : [201, 202].includes(invoice.operation.status);
    },
    async download(type) {
      const now = new Date();

      this.$store.commit('ui/addNotification', {
        type: 'info',
        content: 'Descargando...',
        dateTime: now,
      });

      await this.$store.dispatch('invoice/getAsset', { type, uuid: this.id });

      this.$store.commit('ui/deleteNotification', now);
    },
    async sendEmail() {
      const now = new Date();

      this.$store.commit('ui/addNotification', {
        type: 'info',
        content: 'Reenviando notificación...',
        dateTime: now,
      });

      await this.$store.dispatch('invoice/resendAssetsEmail', this.id);

      this.$store.commit('ui/deleteNotification', now);
      this.$store.dispatch('addTemporalNotification', {
        type: 'success',
        content: 'El correo con los archivos se reenvió correctamente.',
      });
    },
    cancelInvoice() {
      this.$modalForm({
        show: true,
        component: 'ReasonCancellation',
        props: {
          invoice: this.invoice,
        },
      });
    },
    onCloseModal() {
      this.modal = false;
    },
    async cancelById() {
      this.isLoading = true;

      try {
        await this.cancelByUuid(this.id);

        this.$store.dispatch('addTemporalNotification', {
          type: 'success',
          content: 'Se ha realizado el proceso satisfactoriamente.',
        });

        this.modal = false;
      } catch (error) {
        this.$store.dispatch('addTemporalNotification', {
          type: 'danger',
          content: `
            Ocurrió un error al tratar de cancelar la nómina. <br>
            ${error.message}
          `,
        });
      }

      this.isLoading = false;
    },
    async regeneratePdf(type, invoice) {
      const companyId = this.company;
      try {
        const now = new Date();
        await this.$store.dispatch('invoice/regeneratePdf', { invoice, companyId });
        this.$store.commit('ui/deleteNotification', now);
        this.$store.dispatch('addTemporalNotification', {
          type: 'success',
          content: 'Pdf generado correctamente',
        });
      } catch (error) {
        this.$store.dispatch('addTemporalNotification', {
          type: 'danger',
          content: `
            Ocurrió un error al tratar de generar el pdf. <br>
            ${error.message}
          `,
        });
      }
    },
  },
};
</script>

<style scoped>
.box.is-centered.confirmation {
  max-width: 400px;
}
</style>
